import { createSlice } from "@reduxjs/toolkit";

import { getPrivileges } from "./PrivilegesThunk";

const initialState={
    loading:true,
    privileges:[],
    userType:null
}


const privilegeSlice=createSlice({
    name:'privilegeSlice',
    initialState,
    reducers: {
        setPrivilegeSlice(state, action) {
          // Create a new array with the updated item
          return {
            ...state,
            ...action.payload
          }
        },
        resetTable(state) {
          // Reset the state to its initial value
          return initialState;
        },
      },
      extraReducers:(builder)=>
       builder.addCase(getPrivileges.fulfilled,(state,action)=>{
         state.privileges=action.payload?.tree
         state.userType=action.payload?.type

          state.loading=false
       }).addCase(getPrivileges.pending,(state,action)=>{
         state.loading=true
       }).addCase(getPrivileges.rejected,(state,action)=>{
         state.loading=false
       })

      
    });

    export const { setPrivilegeSlice } =privilegeSlice.actions;
    export default privilegeSlice.reducer;